export default "/packs/images/scroll-indicator~707a28b4fc5771b1afd55449ac8b39cb.png";